import UnavailableFieldRow from "./UnavailableFieldRow";
import { ConfigurationPath } from "../../types/FormState.types";
import { useConfigurationField } from "../../context/ConfigurationFormContext";
import React from "react";
import { Box, Typography, Switch } from "@mui/material";

interface SwitchRowProps {
	label: string;
	caption: string;
	switchName: ConfigurationPath;
	checked: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SwitchRow: React.FC<SwitchRowProps> = ({
	label,
	caption,
	switchName,
	checked,
	onChange,
}) => {
	const { disabled, readError } = useConfigurationField(switchName);
	if (readError) return <UnavailableFieldRow label={label} caption={caption} message={readError} />;
	return (
		<Box className="configuration-row">
			<Box>
				<Typography variant="body1">{label}</Typography>
				<Typography variant="caption">{caption}</Typography>
			</Box>
			<Switch name={switchName} checked={checked} onChange={onChange} disabled={disabled} />
		</Box>
	);
};

export default SwitchRow;
